import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useProduct } from "../../../hooks/product";
import ReactDOM from "react-dom";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../../style.module.scss"
import cls from './style.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'js-cookie'

import ProductReview from '../../components/product-review';
import ProductYouLikes from '../../components/product-you-likes';
import ProductMainContainer from '../../components/product-main-container/index';
import ProductNav from '../../components/product-nav'
import ProductRelatedSearcher from '../../components/product-related-searcher'
import ProductAddtocartContainer from "../../components/product-addtocart-container/index"
import ProductShippingInfo from "../../components/product-shipping-info"
import ProductGoodKnow from '../../components/product-good-know'
import ProductBeautyLooks from '../../components/product-beauty-looks'
import ProductDiscountMessage from '../../components/product-discount-message'
// import ProductOftenWith from '../../components/product-often-with'
import ProductShopTheLook from '../../components/product-shop-the-look'
import ProductSubscribe from '../../components/product-subscribe'
import ProductBabiesLooks from '../../components/product-babies-looks'
import { Iconfont } from '../../../../components/icon/iconfont';
import Footer from '../../../../layout/fragments/footer';
import Affix from '../../../../components/affix';

import FlyToCart from '../../../listing/components/cart/fly-to-cart';
// import IndexLottery from "../../../components/index-lottery/rotary-draw/rotary-draw"
// import IndexFixicon from '../components/index-fixicon';
import ProductOffInfo from '../../components/product-off-info';
import { fetchProductShopTheLookNew } from '../../../../../api';
import { useParams } from 'react-router-dom';
import useOpenWindow from '../../../../hooks/open-window';
import ProductTrends from '../../components/product-trends';
// import ThumbImage from '../../components/thumb-image';
import { DiscountAlert } from '../../components/product-main-container/price-discount-alert';
import { useQuery } from '../../../../hooks/common';
import ProductVideo from '../../components/product-video'
import { FormattedMessage } from 'react-intl';


const Tabs = props => {
    useStyles(cls)
    const [tabIndex, setTabIndex] = useState(0)
    const {
        tabs,
        innerRef
    } = props

    return <div className={cls.Tabs} ref={innerRef}>
        <div className={`${cls.TabHeaders} ${tabs?.length > 1 ? '' : cls.Single}`}>
            {
                tabs.map((item, index) => {
                    return <span onClick={() => setTabIndex(index)} key={index} className={`${cls.TabHeader} ${index === tabIndex ? cls.Active : ''}`}>
                        {item.title}
                    </span>
                })
            }
        </div>

        <div className={cls.TabContents}>
            {
                tabs.map((item, index) => {
                    return <div key={index} className={`${cls.TabContent} ${index === tabIndex ? cls.Active : ''}`}>
                        {item.content}
                    </div>
                })
            }
        </div>
    </div>
}


const NormalPage = props => {
    useStyles(classes)
    const productHooks = useProduct();
    const {
        productVO,
        selectedProduct,
        selectedVariant,
        reviewSummary,
        // discountMessage,
        cartImage,
        isBeautyMakeup,
        selectVariant,
        taglia,
        productSizeData,
        clogs
    } = productHooks

    const { selectedProductId } = productVO

    const getTotalSummary = useCallback(sm => {
        let commentSummary = sm?.commentSummary
        let score1 = parseInt((commentSummary?.score1)), score2 = parseInt((commentSummary?.score2)), score3 = parseInt((commentSummary?.score3)), score4 = parseInt((commentSummary?.score4)), score5 = parseInt((commentSummary?.score5));
        let total = score1 + score2 + score3 + score4 + score5;
        let avgScore = (score1 + 2 * score2 + 3 * score3 + 4 * score4 + 5 * score5) / total;
        return { ...sm, total, avgScore }
    }, [])

    const reviewItem = getTotalSummary(reviewSummary)

    const isBabiesLook = !!(selectedProduct?.babiesLooks?.length > 0);

    const [navId, setNavId] = useState("mainNav")
    const [productMessageShow, setProductMessageShow] = useState(false);

    const scrollRef = useRef(true);
    const pageParams = useParams()
    const idRef = useRef(null);
    const query = useQuery()
    const pageProduct = useSelector((state) => state.pageProduct);
    const { promotionalActivities } = selectedProduct
    const { coupons } = selectedVariant?.couponActivity || selectedProduct?.couponActivity || {}


    const [shopTheLookMainId, setShopTheLookMainId] = useState(null);
    const [shopTheLookNewData, setShopTheLookNewData] = useState(null)
    const { show: reviewModalShow, setShow: setReviewModalShow } = useOpenWindow('review')

    const { show: babiesLookShow, setShow: setBabiesLookShow } = useOpenWindow('babies-looks')
    const [showNav, setShowNav] = useState(false);
    const [showProm, setShowProm] = useState(false) // 展示 promotion 折后价
    const [showAddToCartModal, setShowAddToCartModal] = useState(false) //显示加购弹窗
    const [showBtnEstimatedPrice, setShowBtnEstimatedPrice] = useState(false) // 显示加购按钮优惠价格
    const isAddOn = query?.product_type == 'addOn'
    const tabsRef = useRef(null)
    const [showFloatingVideo, setShowFloatingVideo] = useState(false)
    const [canShowFloating, setCanShowFloating] = useState(false)

    const changeSelectedNavId = (id) => {
        setNavId(id)
        scrollRef.current = false
        if (idRef.current) {
            clearTimeout(idRef.current)
        }

        if (id == "mainNav") {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        } else {
            if (document.getElementById(id)) {
                let domCurrent = document.getElementById(id);
                let currentOffsetTop = domCurrent.offsetTop + domCurrent.offsetParent.offsetTop;
                // console.log('currentOffsetTop', currentOffsetTop)

                window.scrollTo({
                    top: currentOffsetTop - 98,
                    behavior: 'smooth'
                })
            }
        }

        // document.getElementById(id)?.scrollIntoView?.({
        //     behavior: 'smooth'
        // })

        idRef.current = setTimeout(() => {
            scrollRef.current = true
        }, 2000)
    }



    const viewHandle = (entry) => {
        if (entry && scrollRef.current) {
            const element = entry.target
            if (element) {
                setNavId(element.id)
            }
        }
    }

    const getShopTheLookNewData = async (params) => {
        const response = await fetchProductShopTheLookNew(params);
        if (response && response?.code == 200) {
            // openShopTheLookMask(true)
            setShopTheLookNewData(response?.result)
        } else {
            // openShopTheLookMask(false)
            setShopTheLookNewData(null)
            console.log("shop the look 新接口请求报错：", response?.result || response)
        }
    }

    useEffect(async () => {
        // setShopTheLookMainId()
        // productMessageShow = Cookies.get("product-coupon");
    }, []);

    useEffect(() => {
        if (selectedProduct?.id) {
            let params = {
                "shopTheLookProductId": selectedProduct?.id,
            }
            if (selectedVariant) {
                params.mainShoppableProduct = {
                    "variantId": selectedVariant?.id,
                    "qty": 1,
                    "selected": true
                }
            }
            getShopTheLookNewData(params)
        }
    }, [selectedProduct, selectedVariant])

    useEffect(() => {
        if (pageProduct.productCouponMsg) {
            if (!Cookies.get("product-coupon")) {
                setProductMessageShow(true);

                Cookies.set('product-coupon', '1', { path: '/', expires: 1 })

                setTimeout(() => {
                    setProductMessageShow(false);
                }, 10000);
            }
        }
    }, [pageProduct.productCouponMsg]);



    let tabs = []
    let onlyReview = false

    if(clogs?.length > 0){
        tabs.push({
            title: <span><FormattedMessage id="item_show" defaultMessage="Item Show" />({clogs?.length})</span>,
            content: <ProductVideo videos={clogs} showFloating={showFloatingVideo && canShowFloating}/>
        })
    }else{
        onlyReview = true
    }

    if (reviewItem?.total > 0) {
        tabs.push({
            title: <span><FormattedMessage id="reviews" defaultMessage="Reviews" />({reviewItem.total})</span>,
            content: <ProductReview hideTitle entryView={viewHandle} reviewItem={reviewItem} productId={selectedProduct?.id} isBabiesLook={isBabiesLook} reviewModalShow={reviewModalShow} onClose={() => setReviewModalShow(false)} onShow={() => setReviewModalShow(true)} />
        })
    }

    const scrollFuc = useCallback(() => {
        const rect = tabsRef.current?.getBoundingClientRect()
        if(rect){
            if (rect.bottom < -40) {
                setShowFloatingVideo(true)
            }else if(rect.top > window.innerHeight){
                setShowFloatingVideo(true)
            }else{
                setShowFloatingVideo(false)
            }
    
            if(rect.top < window.innerHeight - 100){
                setCanShowFloating(true)
            }
        }
    }, [])
        


    useEffect(() => {
        window.addEventListener('scroll', scrollFuc)
        return () => {
            window.removeEventListener('scroll', scrollFuc)
        }
    }, [])


    return (<div className={classes.ProductContainer}>
        <ProductNav navId={navId} changeSelectedNavId={changeSelectedNavId} reviewItem={reviewItem} showNav={showNav} setShowNav={setShowNav} />

        {
            productMessageShow && <>
                <Affix offsetTop={44}>
                    <div className={classes.ProductCartCoupon}>
                        <div>
                            <Iconfont>&#xe6d9;</Iconfont>
                            <span>{pageProduct.productCouponMsg}</span>
                        </div>
                    </div>
                </Affix>
            </>
        }

        <ProductMainContainer
            productHooks={productHooks}
            entryView={viewHandle}
            navId={navId}
            reviewItem={reviewItem}
            onShow={() => setReviewModalShow(true)}
            showProm={showProm}
            setShowProm={setShowProm}
            showAddToCartModal={showAddToCartModal}
            setShowAddToCartModal={setShowAddToCartModal}
            setShowBtnEstimatedPrice={setShowBtnEstimatedPrice}
        />


        {
            promotionalActivities?.length > 0 &&
            <ProductOffInfo
                promotions={promotionalActivities}
                // promotions={coupons}
                productId={selectedProductId}
                setShowProm={setShowProm} />
        }

        {
            isBabiesLook &&
            <ProductBabiesLooks
                babiesLooks={selectedProduct.babiesLooks}
                selectedProduct={selectedProduct}
                babiesLookShow={babiesLookShow}
                setBabiesLookShow={setBabiesLookShow}
                hasRollingMessage={productVO?.rollingMessages}
            />
        }


        <ProductShippingInfo productVO={productVO} isBeautyMakeup={isBeautyMakeup} selectedProduct={selectedProduct} selectedVariant={selectedVariant} taglia={taglia} productSizeData={productSizeData} />

        {
            isBeautyMakeup && selectedProduct?.beautyGoodToKnow?.length > 0 && <ProductGoodKnow goodKnow={selectedProduct.beautyGoodToKnow} />
        }


        {/* <ProductVideo /> */}

        {/* {
            reviewItem?.total > 0 && <ProductReview entryView={viewHandle} reviewItem={reviewItem} productId={selectedProduct?.id} isBabiesLook={isBabiesLook} reviewModalShow={reviewModalShow} onClose={() => setReviewModalShow(false)} onShow={() => setReviewModalShow(true)} />
        } */}

        {
            onlyReview && reviewItem?.total > 0 && <ProductReview entryView={viewHandle} reviewItem={reviewItem} productId={selectedProduct?.id} isBabiesLook={isBabiesLook} reviewModalShow={reviewModalShow} onClose={() => setReviewModalShow(false)} onShow={() => setReviewModalShow(true)} />
        }

        {
            !onlyReview && tabs?.length > 0 && <Tabs tabs={tabs} innerRef={tabsRef} />
        }

        {
            isBeautyMakeup && productVO?.beautyLooks?.length > 0 && <ProductBeautyLooks beautyLooks={productVO.beautyLooks} />
        }

        {
            shopTheLookNewData &&
            <ProductShopTheLook
                productHooks={productHooks}
                productId={selectedProduct?.id}
                shopTheLookData={shopTheLookNewData}
                updateShopTheLook={params => getShopTheLookNewData(params)}
                pageParamsId={pageParams?.id}
            // openShopTheLookMask={() => openShopTheLookMask(true)}
            />
        }


        <ProductSubscribe />

        <ProductDiscountMessage banner={productVO?.productBanner} />

        {
            productVO?.trends?.trendItems?.length > 0 && <ProductTrends trends={productVO.trends} />
        }

        <ProductYouLikes entryView={viewHandle} productId={selectedProduct?.id} productHooks={productHooks} />

        <ProductRelatedSearcher tags={selectedProduct?.tags} />

        {/* {
                shopTheLookNewData &&
                <ShopTheLookMask 
                    productHooks={productHooks}
                    show={showShopTheLookMask} 
                    data={shopTheLookNewData} 
                    changeData={params => getShopTheLookNewData(params)}
                    onClose={() => openShopTheLookMask(false)}
                    />
            } */}

        <Footer />

        <ProductAddtocartContainer
            productHooks={productHooks}
            bottomBanner={pageProduct?.bottomBanner}
            babiesLookShow={babiesLookShow}
            showAddToCartModal={showAddToCartModal}
            setShowAddToCartModal={setShowAddToCartModal}
            estimatedPrice={selectedProduct?.estimatedPrice}
            showBtnEstimatedPrice={showBtnEstimatedPrice && selectedProduct?.estimatedPrice && !isAddOn}
        />

        {
            cartImage && (typeof window !== 'undefined') && ReactDOM.createPortal(<FlyToCart image={cartImage} />, document.getElementById('root'))
        }

        {/* {
            pageProduct?.abTest === "A" && <ThumbImage fixNav={showNav} product={selectedProduct} selectedVariant={selectedVariant} />
        } */}

        {/* <IndexLottery /> */}
        {/* <IndexFixicon /> */}

    </div>
    )
}

export default NormalPage;